export function isDigitalProduct(product: { productType: string }): boolean {
  return product.productType === 'digitalCard';
}
